import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';
import splitHtmlString from '../utilities/splitHtmlString.js';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);

const effect = (type, block, scrollTrigger = null) => {
  if (type === 'words') {
    const split = SplitText.create(block, {
      type: 'words',
      mask: 'words',
    });

    gsap.fromTo(
      split.masks,
      {
        clipPath: 'inset(50% 0% 50% 0%)',
        overflow: 'clip',
      },
      {
        duration: 0.75,
        ease: 'power3.out',
        paused: true,
        stagger: 0.0375,
        clipPath: 'inset(-100% 0% -100% 0%)',
        overflow: 'visible',
        scrollTrigger,
      }
    );
    gsap.fromTo(
      split.words,
      {
        opacity: 0,
        translateY: '80%',
      },
      {
        duration: 0.5,
        ease: 'power3.out',
        paused: true,
        stagger: 0.0375,
        opacity: 1,
        translateY: 0,
        scrollTrigger,
      }
    );
  }
};

const setup = () => {
  let mediaManager = gsap.matchMedia();

  const textBlocks = gsap.utils.toArray(
    '[data-w-scroll-trigger="children"], [data-w-scroll-trigger="letters"], [data-w-scroll-trigger="words"]'
  );
  if (textBlocks) {
    mediaManager.add(
      {
        isMobile: `(max-width: 768px), (min-width: 768px) and (max-width: 1366px) and (orientation: portrait)`,
        isDesktop: `(min-width: 768px) and (max-width: 1366px) and (orientation: landscape), (min-width: 1366px)`,
      },
      (context) => {
        let { isDesktop, isMobile } = context.conditions;

        if (isDesktop) {
          textBlocks.forEach((block) => {
            const trigger =
              block.closest('[data-w-scroll-trigger-parent]') ?? block;

            const type = block.getAttribute('data-w-scroll-trigger');

            const scrollTrigger = {
              trigger: trigger,
              start: 'top 80%',
              end: 'top 20%',
              // scrub: true,
              // markers: true,
            };

            effect(type, block, scrollTrigger);
          });
        }
      }
    );
  }
};

export default function TextEffects() {
  return {
    init: () => {
      setup();
    },
  };
}

export { effect as applyTextEffect };
